export enum ZendeskDepartments {
  CustomerCare = 'Moda Customer Care',
  PrivateClientAdvisors = 'PCA Live Chat'
}

export enum ZendeskStatus {
  Away = 'away',
  Offline = 'offline',
  Online = 'online'
}

export enum ZendeskTrackEvent {
  ChatDisplayed = 'Chat Displayed',
  ChatUsed = 'Chat Used'
}

export const enum ZendeskTrackEventSource {
  Account = 'Account',
  ContactCare = 'Contact Care',
  Product = 'Product'
}

export enum ZendeskWidgetModules {
  Launcher = 'launcher',
  Widget = 'webWidget'
}

export type ZendeskCustomScript = {
  id: string;
  path: string;
};

export type ZendeskCustomStyleSheet = {
  id: string;
  path: string;
};

/** Zendesk Web Widget Settings as defined in https://developer.zendesk.com/api-reference/widget/core/ */

export type ZendeskSettings = {
  webWidget?: ZendeskWebWidgetSettings;
};

type ZendeskAnswerBotSettings = {
  suppress?: boolean;
};

type ZendeskChatConciergeSettings = {
  name?: string;
  title?: ZendeskLocaleTextSettings;
};

type ZendeskChatDepartmentsSettings = {
  select?: ZendeskDepartments;
};

type ZendeskChatSettings = {
  color?: ZendeskColorSettings;
  concierge?: ZendeskChatConciergeSettings;
  contactForm?: ZendeskContactFormSettings;
  departments?: ZendeskChatDepartmentsSettings;
  helpCenter?: ZendeskHelpCenterSettings;
  hideWhenOffline?: boolean;
  suppress?: boolean;
  title?: ZendeskLocaleTextSettings;
};

type ZendeskColorSettings = {
  articleLinks?: string;
  button?: string;
  header?: string;
  launcher?: string;
  launcherText?: string;
  resultLists?: string;
  theme?: string;
};

type ZendeskContactFormSettings = {
  suppress?: boolean;
};

type ZendeskHelpCenterSettings = {
  suppress?: boolean;
};

type ZendeskLocaleTextSettings = {
  [key: string]: string;
};

type ZendeskUserDetails = {
  [key: 'email' | 'name' | 'phone']:
    | {
        value: string;
      }
    | string;
};

/** Zendesk Chat API as described in https://developer.zendesk.com/api-reference/widget/chat-api/ */

export enum ZendeskAnswerBotAction {
  ArticleViewed = 'Answer Bot Article Viewed'
}

export enum ZendeskChatAction {
  CommentSubmitted = 'Chat Comment Submitted',
  Opened = 'Chat Opened',
  RatingBad = 'Chat Rating Bad',
  RatingGood = 'Chat Rating Good',
  RatingRemoved = 'Chat Rating Removed',
  RequestFormSubmitted = 'Chat Request Form Submitted',
  ServedByOperator = 'Chat Served by Operator',
  Shown = 'Chat Shown'
}

export enum ZendeskContactFormAction {
  Shown = 'Contact Form Shown',
  Submitted = 'Contact Form Submitted'
}

export enum ZendeskHelpCenterAction {
  ArticleViewed = 'Help Center Article Viewed',
  Search = 'Help Center Search',
  Shown = 'Help Center Shown',
  ViewOriginalArticleClicked = 'Help Center View Original Article Clicked'
}

export enum ZendeskWebWidgetAction {
  Minimised = 'Web Widget Minimised',
  Opened = 'Web Widget Opened'
}

type ZendeskWidgetAction =
  | string
  | ZendeskAnswerBotAction
  | ZendeskChatAction
  | ZendeskContactFormAction
  | ZendeskHelpCenterAction
  | ZendeskWebWidgetAction;

export type ZendeskChatDepartment = {
  id: number;
  name: string;
  status: ZendeskStatus;
};

export type ZendeskWidgetUserEvent = {
  action: ZendeskWidgetAction;
  category: string;
};
